export default {
  name: 'inv-strat-diversified-info-dialog',
  props: {
    show: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    dismiss() {
      this.$emit('close');
    },
  },
};
